<template>
  <div style="height: 100%">
    <FieldCustomize
      v-if="isFieldCustomize"
      @handleAddCustomizedField="handleAddCustomizedField"
      @cancel="closeMessageBox"
      @add="getData"
    ></FieldCustomize>
    <div class="strategic-area" v-show="!isFieldCustomize">
      <h1 class="title">网络舆情主题</h1>
      <div class="main">
        <div class="operation-wrapper">
          <el-button
            type="primary"
            class="edit-btn"
            :class="{
              'button-active': this.isActive,
              'button-inactive': !this.isActive,
            }"
            @click="switchStatus"
            >编辑</el-button
          >
          <i class="el-icon-plus" @click="isFieldCustomize = true"></i>
        </div>
        <TypeItem
          v-for="(item, index) in fieldList"
          :name="item.name"
          :index="index"
          :key="index"
          :close-enable="isActive"
          @handleSelected="handleSelected"
          @deleteItem="deleteItem(item.id)"
        ></TypeItem>
      </div>
    </div>
  </div>
</template>

<script>
import TypeItem from "@/components/FieldCustomize/TypeItem";
import FieldCustomize from "@/components/FieldCustomize/FieldCustomize";
import enableFieldList from "@/modules/enableFieldList";
import { updateRegionValue } from "@/views/News/index";
import api from "@/services/python";
export default {
  components: {
    TypeItem,
    FieldCustomize,
  },
  data() {
    return {
      fieldList: [
        // "海洋信息", "电磁空间"
      ],
      isFieldCustomize: false,
      isActive: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    closeMessageBox(){
      this.isFieldCustomize = false
      // 自刷新
      this.getData();
    },
    handleAddCustomizedField(param) {
      const { name, selectedList } = param;
      console.log(selectedList);
      this.fieldList.push(name);
      this.isFieldCustomize = false;
    },
    deleteItem(item) {
      // this.fieldList.splice(itemIndex, 1)
      // 删除
      this.$confirm("此操作将永久删除该领域, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await api.domains.delete(item).response.then((res) => res.data);
          if (res.code == 200) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
          this.getData();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelected(param) {
      const { name } = param;
      if (!enableFieldList.includes(name)) {
        this.$message.warning("暂无数据!");
        return;
      }
      //判断领域是否发生变化
      if (name !== this.$store.state.systemType) {
        //更新store中的领域信息
        this.$store.commit("setSystemType", name);
        //更新store中的regionValue信息
        updateRegionValue(this, name);
      }

      this.$store.commit("setMenuLevel", 2);
      this.$router.push("/News");
    },
    switchStatus() {
      this.isActive = !this.isActive;
    },
    // 获取数据
    async getData() {
      const params = {
        page_size: 100,
        page_to: 1,
      };
      const res = await api.domains
        .list({}, params)
        .response.then((res) => res.data);
      if (res.code == 200) {
        this.fieldList = res.data.records;
        // console.log("this.fieldList", this.fieldList);
      }
    },
  },
};
</script>

<style lang="scss">
$border: 2px solid #aaa;
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
.strategic-area {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  & .title {
    position: relative;
    top: -10%;
  }

  & .main {
    position: relative;
    height: 55%;
    width: 40%;
    border-radius: 10px;
    border: $border;
    box-sizing: border-box;
    padding: 4vw;
    line-height: 8vh;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    // display: flex;
    // flex-wrap: wrap;

    // & .type-item:not(:nth-of-type(6n)) {
    //   margin-right: 2%;
    // }
    // justify-content: space-between;

    & .operation-wrapper {
      & .edit-btn {
        border: none;
        margin-right: 10px;
      }
      & .button-active {
        box-shadow: 0 0 1.5em $innerLight inset;
        background-color: #212a4b;
      }
      & .button-inactive {
        box-shadow: 0 0 1.5em $innerLight inset;
        background-color: rgb(8, 14, 32);
      }
      position: absolute;
      font-size: 20px;
      top: 0vh;
      right: 2vw;
      cursor: pointer;
    }
  }
}
</style>
